@include host-component-properties;

.utilization-icon {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: px-to-rem(4);
  line-height: 1;
}
